import React, { useEffect, useState, useContext, Fragment } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import "components/sales/layoutChange/layout.css";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DeleteMrfTypePopup from "../DeleteMrfTypePopup";

const MrfTypes = ({ getMrfTypeList, mrfTypeData = {} }) => {
  const headers = ["Type", "ERP Code", "Status", "Created At", "Action"];

  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showDeleteMrfTypePopup, setShowDeleteMrfTypePopup] = useState(false);
  const [selectedMrfTypeId, setSelectedMrfTypeId] = useState(null);
  const { baseUrl } = useContext(BaseUrl);


  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getMrfTypeList(null, 1);
      setIsLoading(false);
    })();
  }, [getMrfTypeList]);

  useEffect(() => {
  const tableData = ["name", "erp_code", "status", "created_at"];

  if (mrfTypeData?.resultSets?.length > 0) {
    const data = mrfTypeData.resultSets.map((element) =>
      Object.assign(
        {},
        ...tableData.map((key) => ({
          [key]:
            key === "status"
              ? element.status == 1
                ? "Active"
                : "Inactive"
              : element[key],
        })),
        {
        Action: [
          {
            name: "Edit MRF Type",
            link: `${baseUrl}/procurement/edit-mrf-type/${element.id}`,
          },
          {
            name: "Delete MRF Type",
            id: element.id,
          },
        ],
      }
    )
  );

    setListData(data);
    setPageCount(Math.ceil(mrfTypeData.total / mrfTypeData.per_page));
  } else {
    setListData([]);
  }
}, [mrfTypeData]);


  const onPageChange = async (val) => {
    setIsLoading(true);
    await getMrfTypeList(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <a
          href={`/dashboard/procurement/add-mrf-type`}
          className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
        >+ Add MRF Type
        </a>
      </Fragment>
    );
  };

  return (
    <Layout
      title="MRF Type List"
      Buttons={headerBtns}
      isLoading={isLoading}
    >

      <div className="row table-margin">
        <div className="col-md-12">
          <TableSection
            data={listData}
            isId={true}
            headers={headers}
            pageCount={pageCount}
            srNo={mrfTypeData?.from}
            onPageChange={onPageChange}
            setShowDeleteMrfTypePopup={setShowDeleteMrfTypePopup}
            setSelectedMrfTypeId={setSelectedMrfTypeId}
          />
        </div>
      </div>

      <DeleteMrfTypePopup
        showDeleteMrfTypePopup={showDeleteMrfTypePopup}
        selectedMrfTypeId={selectedMrfTypeId}
        onClosePopup={() => setShowDeleteMrfTypePopup(false)}
      />

    </Layout>
  );
};

export default MrfTypes;
